// The motion engine is its own chunk, fetched once the page is idle, so it never
// competes with first paint or hydration. The career wires do not wait for it:
// they draw from CSS keyed on the `bp-js` class set in the document head.
export default defineNuxtPlugin((nuxtApp) => {
  const router = useRouter()

  const start = () => {
    import('~/lib/blueprint-motion')
      .then(({ startBlueprintMotion }) => startBlueprintMotion(router))
  }

  nuxtApp.hook('app:suspense:resolve', () => {
    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(start, { timeout: 1500 })
    } else {
      setTimeout(start, 200)
    }
  })
})
